import { gcloudStorageApi } from 'lib/api/client'
import { SpecRequest, SpecResponse } from './spec.types'

export const getSpec = async (request: SpecRequest): Promise<SpecResponse> => {
  const { data } = await gcloudStorageApi.get<SpecResponse>('/spec', {
    params: request,
  })

  return data
}
